import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/uk/501/',
    component: ComponentCreator('/uk/501/', 'ccd'),
    exact: true
  },
  {
    path: '/uk/articles/',
    component: ComponentCreator('/uk/articles/', '1de'),
    exact: true
  },
  {
    path: '/uk/articles/2024/07/09/diskusija-lj-nj-cyrl/',
    component: ComponentCreator('/uk/articles/2024/07/09/diskusija-lj-nj-cyrl/', 'b76'),
    exact: true
  },
  {
    path: '/uk/articles/2024/07/09/diskusija-lj-nj/',
    component: ComponentCreator('/uk/articles/2024/07/09/diskusija-lj-nj/', 'b9a'),
    exact: true
  },
  {
    path: '/uk/articles/archive/',
    component: ComponentCreator('/uk/articles/archive/', 'ab4'),
    exact: true
  },
  {
    path: '/uk/articles/authors/',
    component: ComponentCreator('/uk/articles/authors/', '429'),
    exact: true
  },
  {
    path: '/uk/search/',
    component: ComponentCreator('/uk/search/', '06b'),
    exact: true
  },
  {
    path: '/uk/',
    component: ComponentCreator('/uk/', '11e'),
    exact: true
  },
  {
    path: '/uk/',
    component: ComponentCreator('/uk/', '7cd'),
    routes: [
      {
        path: '/uk/',
        component: ComponentCreator('/uk/', '4ed'),
        routes: [
          {
            path: '/uk/tags/',
            component: ComponentCreator('/uk/tags/', '389'),
            exact: true
          },
          {
            path: '/uk/tags/comparative/',
            component: ComponentCreator('/uk/tags/comparative/', 'ec9'),
            exact: true
          },
          {
            path: '/uk/tags/grammar/',
            component: ComponentCreator('/uk/tags/grammar/', '28f'),
            exact: true
          },
          {
            path: '/uk/tags/interslavic/',
            component: ComponentCreator('/uk/tags/interslavic/', 'e15'),
            exact: true
          },
          {
            path: '/uk/tags/language-learning/',
            component: ComponentCreator('/uk/tags/language-learning/', '3fc'),
            exact: true
          },
          {
            path: '/uk/tags/linguistics/',
            component: ComponentCreator('/uk/tags/linguistics/', 'ed1'),
            exact: true
          },
          {
            path: '/uk/tags/personal-pronouns/',
            component: ComponentCreator('/uk/tags/personal-pronouns/', '999'),
            exact: true
          },
          {
            path: '/uk/tags/pronouns/',
            component: ComponentCreator('/uk/tags/pronouns/', '379'),
            exact: true
          },
          {
            path: '/uk/tags/slavic-languages/',
            component: ComponentCreator('/uk/tags/slavic-languages/', '931'),
            exact: true
          },
          {
            path: '/uk/tags/вивчення-мови/',
            component: ComponentCreator('/uk/tags/вивчення-мови/', '1cd'),
            exact: true
          },
          {
            path: '/uk/tags/граматика/',
            component: ComponentCreator('/uk/tags/граматика/', '4e5'),
            exact: true
          },
          {
            path: '/uk/tags/займенники/',
            component: ComponentCreator('/uk/tags/займенники/', '2dc'),
            exact: true
          },
          {
            path: '/uk/tags/міжсловянська-мова/',
            component: ComponentCreator('/uk/tags/міжсловянська-мова/', 'c70'),
            exact: true
          },
          {
            path: '/uk/tags/міжсловянська/',
            component: ComponentCreator('/uk/tags/міжсловянська/', '3df'),
            exact: true
          },
          {
            path: '/uk/tags/порівняння-мов/',
            component: ComponentCreator('/uk/tags/порівняння-мов/', '3c5'),
            exact: true
          },
          {
            path: '/uk/',
            component: ComponentCreator('/uk/', 'd32'),
            routes: [
              {
                path: '/uk/learn/faq/',
                component: ComponentCreator('/uk/learn/faq/', '08b'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/grammar/',
                component: ComponentCreator('/uk/learn/grammar/', '2fb'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/grammar/adjectives/',
                component: ComponentCreator('/uk/learn/grammar/adjectives/', 'd76'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/grammar/conjunctions/',
                component: ComponentCreator('/uk/learn/grammar/conjunctions/', 'eaf'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/grammar/nouns/',
                component: ComponentCreator('/uk/learn/grammar/nouns/', '7ba'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/grammar/numerals/',
                component: ComponentCreator('/uk/learn/grammar/numerals/', '10d'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/grammar/prepositions/',
                component: ComponentCreator('/uk/learn/grammar/prepositions/', '7ea'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/grammar/pronouns/',
                component: ComponentCreator('/uk/learn/grammar/pronouns/', 'b95'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/grammar/syntax/',
                component: ComponentCreator('/uk/learn/grammar/syntax/', '4ee'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/grammar/verbs/',
                component: ComponentCreator('/uk/learn/grammar/verbs/', 'e2e'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/introduction/',
                component: ComponentCreator('/uk/learn/introduction/', '49b'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/misc/constructed-slavic-languages/',
                component: ComponentCreator('/uk/learn/misc/constructed-slavic-languages/', '7f8'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/misc/design-criteria/',
                component: ComponentCreator('/uk/learn/misc/design-criteria/', 'd3d'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/misc/history/',
                component: ComponentCreator('/uk/learn/misc/history/', '5df'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/misc/language-comparison/',
                component: ComponentCreator('/uk/learn/misc/language-comparison/', '00c'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/misc/numbers-1-10/',
                component: ComponentCreator('/uk/learn/misc/numbers-1-10/', '464'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/misc/pan-slavic-relay/',
                component: ComponentCreator('/uk/learn/misc/pan-slavic-relay/', '386'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/misc/personal-pronouns/',
                component: ComponentCreator('/uk/learn/misc/personal-pronouns/', 'ae2'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/orthography/',
                component: ComponentCreator('/uk/learn/orthography/', '86c'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/phonology/',
                component: ComponentCreator('/uk/learn/phonology/', '7d4'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/pronunciation/',
                component: ComponentCreator('/uk/learn/pronunciation/', 'ce1'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/simple-grammar/',
                component: ComponentCreator('/uk/learn/simple-grammar/', 'f34'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/simple-grammar/level-1/',
                component: ComponentCreator('/uk/learn/simple-grammar/level-1/', '17d'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/simple-grammar/level-2/',
                component: ComponentCreator('/uk/learn/simple-grammar/level-2/', '10a'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/vocabulary/derivation/',
                component: ComponentCreator('/uk/learn/vocabulary/derivation/', '23b'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/vocabulary/flavourisation/',
                component: ComponentCreator('/uk/learn/vocabulary/flavourisation/', '2f1'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/vocabulary/word-formation/',
                component: ComponentCreator('/uk/learn/vocabulary/word-formation/', '466'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/resources/',
                component: ComponentCreator('/uk/resources/', 'dcc'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/uk/resources/applets/',
                component: ComponentCreator('/uk/resources/applets/', 'c2f'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/uk/resources/applets/intelligibility/',
                component: ComponentCreator('/uk/resources/applets/intelligibility/', 'f2f'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/uk/resources/applets/transliterator/',
                component: ComponentCreator('/uk/resources/applets/transliterator/', 'f6c'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/uk/resources/keyboards/',
                component: ComponentCreator('/uk/resources/keyboards/', '57d'),
                exact: true,
                sidebar: "resourcesSidebar"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
